module.exports = __webpack_public_path__ + "static/media/seconImg.abbba1bc.png";